export default ['Prélèvement automatique', 'CESU', 'Avance immédiate']